function CalculateTime(decimalTime) {
  // Extract hours and minutes
  var hours = Math.floor(decimalTime);
  var minutes = Math.round((decimalTime - hours) * 60);

  // Format the output
  var timeString = hours;
  if (minutes > 9) {
    timeString += ":" + minutes + " hr";
  } else if (minutes > 0) {
    timeString += ":0" + minutes + " hr";
  } else {
    timeString += ":00 hr";
  }

  return timeString;
}
function addTimeToDate(currentDate, hoursToAdd) {
  return new Date(new Date(currentDate).getTime() + Number(hoursToAdd) * 3600000);
}
export { CalculateTime, addTimeToDate };
